import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconHeartComponent } from "./med-icon-heart.component";

@NgModule({
  declarations: [
    MedIconHeartComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconHeartComponent,
  ],
})
export class MedIconHeartModule { }
